import { useLayoutEffect, type ReactNode } from 'react';

interface InternalLightModeBoundaryProps {
  children: ReactNode;
}

export function InternalLightModeBoundary({ children }: InternalLightModeBoundaryProps) {
  useLayoutEffect(() => {
    document.documentElement.classList.remove('dark');

    try {
      window.localStorage.removeItem('theme');
    } catch {
      // Storage can be unavailable; the visual light-mode invariant is already applied.
    }
  }, []);

  return <>{children}</>;
}
